export const formatString = (str, replacementChar = "") => {
  if (str) {
    return (str+'')
      ?.replace(/[^a-zA-Z\s]/g, "") // Keep letters and spaces
      ?.replace(/\s+/g, replacementChar) // Replace one or more spaces with the replacement character
      ?.toLowerCase(); // Convert to lowercase
  }
  return str;
};
